import { Pipe, PipeTransform } from '@angular/core';
import { AppComponentBaseDirective } from '../directives/app-component-base.directive';

@Pipe({
  name: 'localize',
  pure: false
})

export class LocalizePipe extends AppComponentBaseDirective implements PipeTransform {
  transform(key: string, ...args: any[]): string {
    return this.l(key, ...args);
  }
}
